export default {
  computed: {
    hostURL() {
      return window.chatmoConfig.hostURL;
    },
    vapidPublicKey() {
      return window.chatmoConfig.vapidPublicKey;
    },
    enabledLanguages() {
      return window.chatmoConfig.enabledLanguages;
    },
    isEnterprise() {
      return window.chatmoConfig.isEnterprise === 'true';
    },
    enterprisePlanName() {
      // returns "community" or "enterprise"
      return 'enterprise';
      //  TODO: Enterprise enabled
      // return window.chatmoConfig?.enterprisePlanName;
    },
  },
};
